import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {CellsContext} from '../../../../../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../../../libs/shared/ui/src/styles/mixins';
import {StyledEmptyDiv, StyledNoResultsDiv} from './cellsEmptyCommon';
import {CellsEmptyHeader} from './cellsEmptyHeader';

/*
 * Props.
 */

interface CellsEmptyMessageProps {
  cellsContext: CellsContext;
  isOffline: boolean;
}

/*
 * Style.
 */

const StyledMessageDiv = styled.div`
  padding: 20px;
  text-align: center;
  color: ${(p) => p.theme.greys.shade60};
  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.semibold};
  ${ellipsis()};
`;

const StyledInboxZeroSubHeadDiv = styled.div`
  text-align: center;
  color: ${(p) => p.theme.greys.shade60};
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.normal};
  padding-top: 10px;
  ${ellipsis()};
`;

/*
 * Component.
 */

export const CellsEmptyMessage: FC<CellsEmptyMessageProps> = (props) => (
  <StyledEmptyDiv>
    <StyledMessageDiv>{renderEmptyMessage(props)}</StyledMessageDiv>
  </StyledEmptyDiv>
);

function renderEmptyMessage(props: CellsEmptyMessageProps) {
  const {cellsContext} = props;
  const {inDrafts, inSent, isAssignedShared, isDelegation, inOpenFilter, searchQuery} = cellsContext;

  if (inDrafts) {
    return <Trans id="cells-empty-drafts">No drafts</Trans>;
  }

  if (inSent) {
    return <Trans id="cells-empty-sentmessages">No sent messages</Trans>;
  }

  if (inOpenFilter && !isAssignedShared && !isDelegation && !searchQuery) {
    return (
      <>
        <Trans id="cells-empty-inboxzero">Inbox zero</Trans>
        <StyledInboxZeroSubHeadDiv>
          <Trans id="cells-empty-conversations">No conversations</Trans>
        </StyledInboxZeroSubHeadDiv>
      </>
    );
  }

  return (
    <StyledNoResultsDiv>
      <CellsEmptyHeader />
    </StyledNoResultsDiv>
  );
}
